import React, { useContext } from "react";
import { theme } from "../theme";
import Metric from "../components/Metric";
import Method from "../components/Method";
import Current from "../components/Current";
import Criteria from "../components/Criteria";
import Trajectory from "../components/Trajectory";
import Forecast from "../components/Forecast";
import Concerns from "../components/Concerns";
import { General } from "../tools/styles";
import calcComplete from "../tools/calcComplete";
import calcForecast from "../tools/calcForecast";
import { WatchContext } from "../WatchContext";
import handleInputChange from "../tools/handleInputChange";
import calcCurrentConcern from "../tools/calcCurrentConcern";
import calcFutureConcern from "../tools/calcFutureConcern";
import BackToDash from "../components/BackToDash";

const Biology = () => {
  
  const { biology, setBiology } = useContext(WatchContext)

  const handleChange = ({ target }) => {

    let data = handleInputChange(biology, target)

    console.log('biology test', data)
    
    data.currentConcern = calcCurrentConcern(data)
    data.forecastLow = calcForecast(data, data.trajectLow)
    data.forecastHigh = calcForecast(data, data.trajectHigh)
    data.futureConcern = calcFutureConcern(data)
    data.complete = calcComplete(data);  
    
    setBiology(data)
  };

  let topicItem = biology.metrics?.filter(
    (item) => item.metric === biology.metric
  )[0] ?? { methods: [] };
  let methods = topicItem.methods.map((item) => item.method) ?? [];

  return (
    <General.Background backgroundColor={`${theme.colors.pdeBlue + 40}`}>
      <General.Heading color={theme.colors.pdeBlue}>Biology</General.Heading>
      <BackToDash/>
      <Metric
        currentValue={biology.metric}
        description="Description of the living community at a site"
        metricArray={biology.metrics}
        handleChange={handleChange}
      />
      <Method
        currentValue={biology.method}
        methodArray={methods}
        handleChange={handleChange}
      />
      <Current
        currentValue={biology.currentValue}
        // valDesc="Negative values represent a loss (erosion, subsidence) of elevation."
        units={biology.units}
        just={biology.currentJust}
        handleChange={handleChange}
      />
      <Criteria
        low={biology.criteriaLow}
        high={biology.criteriaHigh}
        units={biology.units}
        type={biology.criteriaType}
        just={biology.criteriaJust}
        handleChange={handleChange}
      />
      <Trajectory
        low={biology.trajectLow}
        high={biology.trajectHigh}
        units={biology.units}
        just={biology.trajectJust}
        handleChange={handleChange}
      />
      <Forecast
        years={biology.forecastYears}
        just={biology.forecastJust}
        units={biology.units}
        forecastLow={biology.forecastLow}
        forecastHigh={biology.forecastHigh}
        handleChange={handleChange}
      />
      <Concerns
        currentConcern={biology.currentConcern}
        futureConcern={biology.futureConcern}
        metric={biology.metric}
      />
     <BackToDash/>
    </General.Background>
  );
};

export default Biology;
